import pino, { LogFn } from 'pino';

interface Logger {
  trace: LogFn;
  debug: LogFn;
  info: LogFn;
  warn: LogFn;
  error: LogFn;
  fatal: LogFn;
  getEnvironment: () => string;
}

// do not include logger in production
const nullLogger: Logger = {
  /* eslint-disable @typescript-eslint/no-empty-function */
  trace: () => {},
  debug: () => {},
  info: () => {},
  warn: () => {},
  error: () => {},
  fatal: () => {},
  getEnvironment: () => 'production',
  /* eslint-enable @typescript-eslint/no-empty-function */
};

const pinoBrowserLogger: Logger = ((): Logger => {
  if (typeof window === 'undefined') {
    return nullLogger;
  }
  const createConsoleWriter = (
    level: 'debug' | 'info' | 'warn' | 'error' | 'trace'
  ) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (o: any): void => {
      const message = o.msg || '';
      const args = o.args || [];
      // eslint-disable-next-line no-console
      console[level](message, ...args);
    };
  };

  const browserLogger = pino({
    level: process.env.EDITOR_LOG_LEVEL || 'trace',
    browser: {
      write: {
        /* eslint-disable no-console */
        debug: createConsoleWriter('debug'),
        info: createConsoleWriter('info'),
        warn: createConsoleWriter('warn'),
        error: createConsoleWriter('error'),
        trace: createConsoleWriter('trace'),
        /* eslint-enable no-console */
      },
    },
  });
  return {
    ...browserLogger,
    // logger only used in development
    getEnvironment: () => 'development',
  };
})();

let logger: Logger;
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
  logger = nullLogger;
} else {
  logger = pinoBrowserLogger;
}

export default logger;
